import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import AdminViewTenantPromotionsEmployeesModal from './AdminViewTenantPromotionsEmployeesModal';
import { Block } from '../../../Component';
import CardTabs from '../../../../pages/components/cards/CardTabs';

const AdminViewTenantPromotionsDashboard = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

 const [open, setOpen] = useState(isOpen);
 const [activeCardTab, setActiveCardTab] = useState("Employees");
 const [page_data, setPageData] = useState(data);

 // Card Tabs
 const tabs = [
  {
   tabName: "Employees"
  }
 ];

 useEffect(() => {
  setOpen(isOpen);
  setPageData(data);
 }, [isOpen, data]);

 return (
  <>
   <Modal isOpen={open} className="modal-dialog-centered" size={"xl"} fullscreen >
    <ModalHeader toggle={closeModal}>Promotions Dashboard {page_data ? ` (${page_data?.tenant?.name})` : ""}</ModalHeader>
    <ModalBody>
     <Block>
      <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
     </Block>
     {
      activeCardTab === "Employees" && (
       <>
        <AdminViewTenantPromotionsEmployeesModal successFunction={successFunction} data={data} tenant_info={tenant_info} user_info={user_info} />
       </>
      )
     }
    </ModalBody>
   </Modal>

  </>
 );
};

export default AdminViewTenantPromotionsDashboard;